import { useEffect, useState } from "react";

/**
 * Kahoot-style score tween — animates from `from` to `to` on mount (and
 * whenever the target changes). Used in the reveal leaderboard so each
 * player's score visibly counts UP by the points they just earned.
 */
export function CountUp({ from, to, duration = 900 }: { from: number; to: number; duration?: number }) {
  const [disp, setDisp] = useState(from);
  useEffect(() => {
    if (from === to) { setDisp(to); return; }
    let raf = 0;
    let startT = 0;
    const tick = (now: number) => {
      if (!startT) startT = now;
      const t = Math.min(1, (now - startT) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisp(Math.round(from + (to - from) * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [from, to, duration]);
  return <>{disp.toLocaleString()}</>;
}
